module.exports = {
  PROCESSING: 'EM_PROCESSAMENTO',
  RETURNED: 'DEVOLVIDO',
  NOT_PROCESSED: 'NAO_REALIZADO'
};
